// extracted by mini-css-extract-plugin
export default {"cls1":"ViewAllSuggestions-cls1__da1790147d8d5f7b0894","cls2":"ViewAllSuggestions-cls2___f80fee3cd3766fedac4 ViewAllSuggestions-cls1__da1790147d8d5f7b0894"};